import React, { Component } from 'react';
import { Input, Table, FormGroup, FormFeedback, Button } from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink} from 'reactstrap';
import classnames from 'classnames';
import TooltipItem from '../../../tools/TooltipItem';
import { IoPersonOutline, IoPersonAddOutline } from 'react-icons/io5'
import { connect } from 'react-redux';
import '../../../../src/custom.css'

class EmpSearchData extends Component {

    constructor(props) {
        super(props);
        this.state = {
            empResponse: [],
            accordionVisible: false,
            activeTab: '1',
            searchType: '',
            returnable: this.props.reduxData.userInfo,
            userDomain: this.props.reduxData.userInfo.username.charAt(this.props.reduxData.userInfo.username.length - 1) >= 0 && this.props.reduxData.userInfo.username.charAt(this.props.reduxData.userInfo.username.length - 1) <= 9 ? "PERGOLA" : "HOOD",
            department: this.props.reduxData.userInfo.level.dept.substring(0, this.props.reduxData.userInfo.level.dept.indexOf("-") - 1),
            departmentpk: this.props.reduxData.userInfo.level.pk,
            phoneUpdateStatus: "",
            roomUpdateStatus: "",
            buildingUpdateStatus: "",
            ipUpdateStatus: "",
            phoneUpdateText: "",
            roomUpdateText: "",
            buildingUpdateText: "",
            ipUpdateText: "",
            priorUpdateVal: "",
            activeDeptPK: [],
            DTMBuildings: [],
            undoList: []
        }
        this.toggle = this.toggle.bind(this);
        //this.hitCallback = this.props.callbackFunction;
        //this.getUserInfo();
        this.apiFetch("GetUserDeptPK", {}, "activeDeptPK")
        //this.getUserDeptPK(this.props.reduxData.userInfo.level.pk);
        //this.getUserInfo();
    }

    async apiFetch(url, body, stateItem) {
        this.props.updateFetchTime()
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            ...body
        }
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.props.reduxData.apiKey },
            body: JSON.stringify(toSend)
        })
        const data = await response.json()
        if (stateItem != "" && stateItem != null) {
            this.setState({
                [stateItem]: data
            })
        }
        if (stateItem == "") {
            return data
        }
        if (url == "GetUserDeptPK") {
            this.apiFetch("GetDTMBuildings", {}, "DTMBuildings")
        }
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    //async getUserDeptPK(dept) {//This controller actually does a couple things. It returns both the PK value of the department that the user is acting as, and a boolean value for whether that
    //                            //department is a primary record for the user. This controller is used in two different components in the Employee Directory, both are only using one of those
    //                            //values, and they are using different values. While that could mean I could split them into different procedures, the values are related strongly enough that
    //                            //I feel it valuable to have them together.
    //                            //This one is using the boolean value for whether this department is the primary department
    //    let toSend = {
    //        userLevel: dept
    //    }
    //    //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let bearerVAR = "Bearer " + this.props.reduxData.apiKey
    //    this.props.updateFetchTime();
    //    const response = await fetch('GetUserDeptPK', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    //localStorage.setItem("lastFetch", moment());
    //    //console.log("user department",data)
    //    this.setState({
    //        activeDeptPK: data
    //    })
    //    this.getBuildChange(dept);
    //}

    //async getBuildChange(dept) {//Warning: the list of buildings this returns is a list of the buildings that are currently in DTM. If all of an employees move out of a building in DTM,
    //                            //that building will no longer be in this list.
    //    let toSend = {
    //        userLevel: dept
    //    }
    //    //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let bearerVAR = "Bearer " + this.props.reduxData.apiKey
    //    this.props.updateFetchTime();
    //    const response = await fetch('GetDTMBuildings', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    //localStorage.setItem("lastFetch", moment());
    //    this.setState({
    //        DTMBuildings: data
    //    })
    //}

    componentDidMount() {
        
    }

    async changeBuild(e, pcid, dept, original, pk) {//We're gonna need to keep changeBuild because of the particular things a dropdown does that textboxes don't
        e.preventDefault();
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        if (e.target.value == this.state.priorUpdateVal) { //This is a bit of a relic from when the building change was a freeform textbox instead of a dropdown. It's being left because if you 
                                                            //ever want to change it back to a textbox you'll need it, and it's kinda useful anyway.
            return;
        }
        let toSend = {}
        if (e.target.value !== "DEFAULT") {//A problem unique to the dropdown, though, is that in order to default the right building (as the building controller only returns the name),
                                            //a DEFAULT value has to be assigned to the right building and the defaultValue made that value. Which means if a user changes their building
                                            //and then changes it back, their building would be listed as 'DEFAULT' in DTM. Recoverable, but probably more than a little jarring. This
                                            //checks to see whether that's trying to happen, and then if it is we don't use the target but instead what we recorded as the original value.
            toSend = {
                userLevel: this.props.reduxData.userInfo.level.pk,
                userDomain: this.state.userDomain,
                targetpcid: pcid,
                targetdept: dept,
                newvalue: e.target.value,
                changeField: "building"
            }
        }
        else {
            toSend = {
                userLevel: this.props.reduxData.userInfo.level.pk,
                userDomain: this.state.userDomain,
                targetpcid: pcid,
                targetdept: dept,
                newvalue: original,
                changeField: "building"
            }
        }
        const response = await fetch('ChangeDirInfo', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        if (data.onestring == "Success") {
            this.setState({
                buildingUpdateStatus: "true"
            })
            setTimeout(() => {//We don't want the green check to be there forever, it'd make it hard to know if a second change was successful
                this.setState({
                    buildingUpdateStatus: ""
                })
            }, 3000)
        }
        else {
            this.setState({
                buildingUpdateStatus: "",
                buildingUpdateText: data.onestring
            })
        }
        //if (this.state.undoList.indexOf(pcid + pk + "building") <= -1) {
        //    this.setState(prevState => ({
        //        undoList: [...prevState.undoList, pcid + pk + "building"]
        //    }))
        //}
        this.setState({
            undoList: [pcid + pk + "building"]
            })
        this.getUserDeptPK(this.props.reduxData.userInfo.level.pk);
    }

    async changePhone(e, pcid, dept, pk) {
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        if (e.target.value == this.state.priorUpdateVal) {//To cut down on useless server calls, if the user clicks on the textbox and doesn't change anything, we'll detect that and not do anything
            return;
        }
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            userDomain: this.state.userDomain,
            targetpcid: pcid,
            targetdept: dept,
            newvalue: e.target.value,
            changeField: "phone"
        }
        const response = await fetch('ChangeDirInfo', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        if (data.onestring == "Success") {
            this.setState({
                phoneUpdateStatus: "true"
            })
            setTimeout(() => {
                this.setState({
                    phoneUpdateStatus: ""
                })
            }, 3000)
        }
        else {
            this.setState({
                phoneUpdateStatus: "false",
                phoneUpdateText: data.onestring
            })
        }
        //if (this.state.undoList.indexOf(pcid + pk + "phone") <= -1) {
        //    this.setState(prevState => ({
        //        undoList: [...prevState.undoList, pcid + pk + "phone"]
        //    }))
        //}
        this.setState({
            undoList: [pcid + pk + "phone"]
            })
    }    

    async undoButton(pcid, dept, type) {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            type: type,
            pcid: pcid,
            department: dept
        }
        const response = await fetch('UndoButtonDir', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        if (data == true) {
            //let currList = this.state.undoList
            //let index = currList.indexOf(pcid + dept + type)
            //currList.splice(index, 1);
            //this.setState({
            //    undoList: currList
            //})
            this.setState({
                undoList: []
                })
            this.props.callbackFunction(data)
        }
    }

    async changeRoom(e, pcid, dept, pk) {
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        if (e.target.value == this.state.priorUpdateVal) {
            return;
        }
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            userDomain: this.state.userDomain,
            targetpcid: pcid,
            targetdept: dept,
            newvalue: e.target.value,
            changeField: "room"
        }
        const response = await fetch('ChangeDirInfo', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        if (data.onestring == "Success") {
            this.setState({
                roomUpdateStatus: "true"
            })
            setTimeout(() => {
                this.setState({
                    roomUpdateStatus: ""
                })
            }, 3000)
        }
        else {
            this.setState({
                roomUpdateStatus: "false",
                roomUpdateText: data.onestring
            })
        }
        //if (this.state.undoList.indexOf(pcid + pk + "room") <= -1) {
        //    this.setState(prevState => ({
        //        undoList: [...prevState.undoList, pcid + pk + "room"]
        //    }))
        //}
        this.setState({
            undoList: [pcid + pk + "room"]
            })
    }

    async changeIP(e, pcid, dept, pk) {
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        if (e.target.value == this.state.priorUpdateVal) {
            return;
        }
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            userDomain: this.state.userDomain,
            targetpcid: pcid,
            targetdept: dept,
            newvalue: e.target.value,
            changeField: "ip"
        }
        const response = await fetch('ChangeDirInfo', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        if (data.onestring == "Success") {
            this.setState({
                ipUpdateStatus: "true"
            })
            setTimeout(() => {
                this.setState({
                    ipUpdateStatus: ""
                })
            }, 3000)
        }
        else {
            this.setState({
                ipUpdateStatus: "false",
                ipUpdateText: data.onestring
            })
        }
        //if (this.state.undoList.indexOf(pcid + pk + "ip") <= -1) {
        //    this.setState(prevState => ({
        //        undoList: [...prevState.undoList, pcid + pk + "ip"]
        //    }))
        //}
        this.setState({
            undoList: [pcid + pk + "ip"]
            })
    }

    recordVal(e) {//When the user focuses on a textbox, we write down what's in the textbox before they start writing
        e.preventDefault(); 
        this.setState({
            priorUpdateVal: e.target.value
        })
    }

    render() {
        return (
            <div key={this.props.key}>
                {this.props.empSearch.map(deptData => (
                    <Nav tabs style={{ display: "inline-block" } }>
                        <NavItem>
                            <TooltipItem id={deptData.pcid + deptData.pk} title={"Division: " + deptData.parentname}>
                                <NavLink
                                    className={classnames({ active: this.state.activeTab === deptData.pk })}
                                    onClick={() => this.toggle(deptData.pk)}
                                >
                                    {deptData.deptName}
                                </NavLink>
                            </TooltipItem>
                        </NavItem>
                    </Nav>
                ))}
                {this.props.empSearch.map(innerData => (
                    <TabContent activeTab={innerData.pcid + this.state.activeTab}>
                        <TabPane tabId={innerData.pcid + innerData.pk}>
                            <Table bordered hover size="sm" responsive>
                                <tbody>
                                    <tr hidden={this.state.department == "INFO TECHNOLOGY" ? false : true}>
                                        <td className={"w-25"} style={{ textAlign: 'right' }}><b>PCID</b></td>
                                        <td className={"w-75"} id={innerData.pcid} >{innerData.pcid}</td>
                                    </tr>
                                    <tr>
                                        <td className={"w-25"} style={{ textAlign: 'right' }}><b>Title</b></td>
                                        <td className={"w-75"} >{innerData.title}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={"w-25"} style={{ textAlign: 'right' }}><b>Role</b></td>
                                        <td classname={"w-75"} >{innerData.role}
                                            <div className="inlineCustom" style={{ float: 'right' }}>
                                                {innerData.isprimary == "Primary" && <IoPersonOutline />}
                                                {innerData.isprimary == "Secondary" && <IoPersonAddOutline />}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={"w-25"} style={{ textAlign: 'right' }}><b>Building</b></td>
                                        <td className={"w-75"} >
                                            {this.state.userDomain == "HOOD" && this.state.activeDeptPK.isprimary == true &&
                                                //What we can do here for conditional rendering is use the && comparator between the logic check we want to govern the rendering and the JSX we
                                                //want to render. The JSX will always be considered true, so as long as the other logic checks are passed the JSX will render.
                                                //In this case, we want to render a select box for when the user's logged in domain is HOOD and their active department is their primary
                                                <FormGroup className="inlineCustom">
                                                    <Input 
                                                        type="select"
                                                        name="buildChange"
                                                        id="buildChange"
                                                        defaultValue="DEFAULT"
                                                        onChange={(e) => this.changeBuild(e, innerData.pcid, innerData.deptpk, innerData.building, innerData.pk)}
                                                        className="inlineCustom"
                                                        invalid={this.state.buildingUpdateStatus == "false" ? true : false}
                                                        valid={this.state.buildingUpdateStatus == "true" ? true : false}
                                                    >
                                                        <option value="DEFAULT">{innerData.building}</option>
                                                        
                                                        {this.state.DTMBuildings.filter(remove => remove.name !== innerData.building).map(item => (
                                                            //So you don't have to loop through every single value in the JSON object in a .map, not if you do the map on a .filter of the JSON
                                                            <option>{item.name}</option>
                                                            ))}
                                                    </Input>
                                                    <FormFeedback className="position-relative" tooltip invalid>{this.state.buildingUpdateText}</FormFeedback>
                                                </FormGroup>
                                            }
                                            {(this.state.userDomain != "HOOD" || this.state.activeDeptPK.isprimary != true) && innerData.building}
                                            &nbsp;{this.state.undoList.indexOf(innerData.pcid + innerData.pk + "building") > -1 &&
                                                <div className="inlineCustom"><Button color="warning" onClick={() => this.undoButton(innerData.pcid, innerData.deptpk, "building")}>Undo</Button></div>
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={"w-25"} style={{ textAlign: 'right' }}><b>Room</b></td>
                                        <td className={"w-75"}><div className="inlineCustom">
                                            {this.state.userDomain == "HOOD" && this.state.activeDeptPK.isprimary == true &&
                                                <FormGroup className="inlineCustom">
                                                    <Input
                                                        type="text"
                                                        name="roomChange"
                                                        id="roomChange"
                                                        defaultValue={innerData.officeRoom}
                                                        onFocus={(e) => this.recordVal(e)}
                                                        onBlur={(e) => this.changeRoom(e, innerData.pcid, innerData.deptpk, innerData.pk)}
                                                        className="inlineCustom"
                                                        invalid={this.state.roomUpdateStatus == "false" ? true : false}
                                                        valid={this.state.roomUpdateStatus == "true" ? true : false}
                                                    />
                                                    <FormFeedback className="position-relative" tooltip invalid>{this.state.roomUpdateText}</FormFeedback>
                                            </FormGroup>
                                            }
                                            {(this.state.userDomain != "HOOD" || this.state.activeDeptPK.isprimary != true) && innerData.officeRoom}
                                            &nbsp;{this.state.undoList.indexOf(innerData.pcid + innerData.pk + "room") > -1 &&
                                                <div className="inlineCustom"><Button color="warning" onClick={() => this.undoButton(innerData.pcid, innerData.deptpk, "room")}>Undo</Button></div>
                                            }
                                        </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={"w-25"} style={{ textAlign: 'right' }}><b>Phone</b></td>
                                        <td className={"w-75"}>
                                            {this.state.userDomain == "HOOD" && this.state.activeDeptPK.isprimary == true &&
                                                <FormGroup className="inlineCustom">
                                                    <Input
                                                        type="text"
                                                        name="phoneChange"
                                                        id="phoneChange"
                                                        defaultValue={innerData.phoneEx}
                                                        onFocus={(e) => this.recordVal(e)}
                                                        onBlur={(e) => this.changePhone(e, innerData.pcid, innerData.deptpk, innerData.pk)}
                                                        className="inlineCustom"
                                                        invalid={this.state.phoneUpdateStatus == "false" ? true : false}
                                                        valid={this.state.phoneUpdateStatus == "true" ? true : false }
                                                    />
                                                    <FormFeedback className="position-relative" tooltip invalid>{this.state.phoneUpdateText}</FormFeedback>
                                                </FormGroup>

                                             }
                                            {(this.state.userDomain != "HOOD" || this.state.activeDeptPK.isprimary != true) && innerData.phoneEx}     
                                            &nbsp;{this.state.undoList.indexOf(innerData.pcid + innerData.pk + "phone") > -1 &&
                                                <div className="inlineCustom"><Button color="warning" onClick={() => this.undoButton(innerData.pcid, innerData.deptpk, "phone")}>Undo</Button></div>
                                            }
                                        </td>
                                    </tr>
                                    <tr hidden={this.state.department == "INFO TECHNOLOGY" ? false : true}>
                                        <td className={"w-25"} style={{ textAlign: 'right' }}><b>PowerCampus User</b></td>
                                        <td classname={"w-75"} >{innerData.pCuser}</td>
                                    </tr>
                                    <tr>
                                        <td className={"w-25"} style={{ textAlign: 'right' }}><b>Email</b></td>
                                        <td className={"w-75"} ><a href={"mailto:" + innerData.email}>{innerData.email}</a></td>
                                    </tr>
                                    <tr hidden={this.state.department == "INFO TECHNOLOGY" ? false : true}>
                                        <td className={"w-25"} style={{ textAlign: 'right' }}><b>IP</b></td>
                                        <td className={"w-75"} >
                                            <FormGroup className="inlineCustom">
                                                <Input
                                            type="text"
                                            name="ipChange"
                                            id="ipChange"
                                                    defaultValue={innerData.ip}
                                                    onFocus={(e) => this.recordVal(e)}
                                                    onBlur={(e) => this.changeIP(e, innerData.pcid, innerData.deptpk, innerData.pk)}
                                            className="inlineCustom"
                                            invalid={this.state.ipUpdateStatus == "false" ? true : false}
                                                    valid={this.state.ipUpdateStatus == "true" ? true : false} />
                                                <FormFeedback className="position-relative" tooltip invalid>{this.state.ipUpdateText}</FormFeedback>
                                            </FormGroup>
                                            &nbsp;{this.state.undoList.indexOf(innerData.pcid + innerData.pk + "ip") > -1 &&
                                                <div className="inlineCustom"><Button color="warning" onClick={() => this.undoButton(innerData.pcid, innerData.deptpk, "ip")}>Undo</Button></div>
                                            }
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </TabPane>
                    </TabContent>
                ))}
            </div>
        );
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(EmpSearchData);